import React from 'react'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { strings } from '@constants'
import { Input, Toggle } from '@base'
import { displayAmount } from '@utils'
import {
	Amount,
	FlexWrapper,
	Heading,
	IconWrapper,
	InfoPanel,
	Label,
	MobileAmountSectionWapper,
	PartialAmountWrapper,
	Sign,
	TotalAmountSection,
	TotalAmountWrapper,
} from '../../style'


const MobileAmountSection = ({
	isScrap,
	state,
	valueChangeHandler,
	isLogisticsQuoteType,
	isAmountPanelOpen,
	isQuoteTypeX,
	setIsAmountPanelOpen,
	setQuoteType,
	staticData,
	amountPanelAnimation,
	renderStaticMessages,
}) => {
	const amountPanelToggler = () => {
		if (!isQuoteTypeX) return
		setIsAmountPanelOpen(!isAmountPanelOpen)
	}
	return (
		<MobileAmountSectionWapper expanded={true}>
			<TotalAmountSection onClick={amountPanelToggler}>
				<FlexWrapper>
					<Label>{strings('select_quote_type')}</Label>
					{isScrap ? (
						<Toggle
							options={[
								{
									label: strings('for'),
									click: setQuoteType('FOR'),
									active: !isQuoteTypeX,
								},
							]}
						/>
					) : (
						<Toggle
							options={[
								{
									label: strings('for'),
									click: setQuoteType('FOR'),
									active: !isQuoteTypeX,
								},
								{
									label: strings('x'),
									click: setQuoteType('EX'),
									active: isQuoteTypeX,
								},
							]}
						/>
					)}
				</FlexWrapper>
				<TotalAmountWrapper>
					<Label>{strings('total_amount_for')}</Label>
					<Amount>{displayAmount(staticData.totalAmount)}</Amount>
				</TotalAmountWrapper>
				{isQuoteTypeX && <IconWrapper>{isAmountPanelOpen ? <ExpandMore /> : <ExpandLess />}</IconWrapper>}
			</TotalAmountSection>
			{isQuoteTypeX && (
				<InfoPanel show={isAmountPanelOpen} amountPanelAnimation={amountPanelAnimation}>
					{renderStaticMessages()}
					<Heading>{strings('total_amount_breakup')}</Heading>
					<PartialAmountWrapper>
						<Label>{strings('quoted_amount_x')}</Label>
						<Amount>{displayAmount(staticData.totalExPrice)}</Amount>
					</PartialAmountWrapper>
					<Sign>+</Sign>
					<PartialAmountWrapper>
						{isLogisticsQuoteType === strings('mt') ? (
							<Input
								id='quote-logistics-quote'
								label={strings('label_logistics_quotation_per_mt')}
								type='number'
								min={0}
								placeholder={strings('placeholder_enter_logistics_quotation_per_mt')}
								value={state.enquiryQuote?.logistics_quote_per_mt}
								onChange={valueChangeHandler(null, 'logistics_quote_per_mt')}
							/>
						) : (
							<Input
								id='quote-logistics-quote'
								label={strings('label_lumpsum_logistics_quotation')}
								type='number'
								min={0}
								placeholder={strings('placeholder_enter_lumpsum_logistics_quotation')}
								value={state.enquiryQuote?.lumpsum_logistics_quote}
								onChange={valueChangeHandler(null, 'lumpsum_logistics_quote')}
							/>
						)}
					</PartialAmountWrapper>
					<Sign>=</Sign>
					<PartialAmountWrapper>
						<Label>{strings('total_amount_for')}</Label>
						<Amount>{displayAmount(staticData.totalAmount)}</Amount>
					</PartialAmountWrapper>
				</InfoPanel>
			)}
		</MobileAmountSectionWapper>
	)
}

export default MobileAmountSection
